import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, ArrowRightIcon, ShieldIcon } from 'lucide-react';
import { SEO } from '../../components/SEO';
export const AlloyGatorPage = () => {
  return <main data-id="element-686">
      <SEO title="AlloyGator Almere | Velgbescherming | BKCustoms" description="Bescherm uw velgen in Almere tegen stoepschade met AlloyGator wielkastbeschermers. Professionele installatie door BKCustoms. Duurzaam en verkrijgbaar in meerdere kleuren." canonical="/diensten/alloygator" data-id="element-687" />
      {/* Header Banner */}
      <div className="relative bg-[#0a0a0a] py-28" data-id="element-688">
        <div className="absolute inset-0 overflow-hidden" data-id="element-689">
          <div className="absolute inset-0 bg-black/80 z-10" data-id="element-690"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/d9Rkg47SKWSVtxvpKhbWvX/1_%281%29.jpg" alt="AlloyGator in Almere" className="w-full h-full object-cover object-center" data-id="element-691" />
        </div>
        <div className="relative z-20 max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-692">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-693">
            <span className="text-[#D6281F]" data-id="element-694">AlloyGator Almere</span> - Bescherm
            uw velgen
          </h1>
          <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-695">
            Premium bescherming voor uw velgen tegen schade van stoepranden met
            onze hoogwaardige AlloyGator wielkastbeschermers in Almere.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mt-8" data-id="element-696">
            <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center" data-id="element-697">
              <span className="mr-2" data-id="element-698">Direct afspraak maken</span>
              <ArrowRightIcon size={16} data-id="element-699" />
            </Link>
            <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10 inline-flex items-center justify-center" data-id="element-700">
              Offerte aanvragen
            </Link>
          </div>
        </div>
      </div>
      {/* Service Description Section */}
      <section className="bg-[#0a0a0a] py-20" data-id="element-701">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-702">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-703">
            {/* Image Section */}
            <div className="w-full lg:w-1/2" data-id="element-704">
              <div className="relative" data-id="element-705">
                <div className="absolute -inset-4 bg-gradient-to-tr from-[#D6281F] via-[#FF6B00] to-[#FFD500] opacity-30 blur-lg rounded-lg" data-id="element-706"></div>
                <div className="relative overflow-hidden rounded-lg border border-white/10 shadow-2xl" data-id="element-707">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/d9Rkg47SKWSVtxvpKhbWvX/1_%281%29.jpg" alt="AlloyGator wielkastbeschermer in Almere" className="w-full h-auto object-cover" data-id="element-708" />
                </div>
              </div>
            </div>
            {/* Content Section */}
            <div className="w-full lg:w-1/2" data-id="element-709">
              <div className="flex items-center mb-6" data-id="element-710">
                <div className="bg-[#D6281F]/20 p-2 rounded-full mr-4" data-id="element-711">
                  <ShieldIcon size={28} className="text-[#D6281F]" data-id="element-712" />
                </div>
                <div className="h-px flex-grow bg-gradient-to-r from-[#D6281F] to-transparent" data-id="element-713"></div>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-714">
                AlloyGator Velgbescherming in Almere
              </h2>
              <p className="text-white/80 text-lg mb-6 leading-relaxed" data-id="element-715">
                AlloyGator is de ultieme bescherming voor uw voertuig in Almere!
                Onze hoogwaardige wielkastbeschermers zijn gemaakt van een
                duurzaam en flexibel materiaal dat uw velgen beschermt tegen
                stoepschade, steenslag en andere beschadigingen.
              </p>
              <p className="text-white/80 text-lg mb-8 leading-relaxed" data-id="element-716">
                Dankzij de eenvoudige installatie door onze specialisten in
                Almere en het strakke design is AlloyGator de perfecte keuze
                voor elke autoliefhebber die zijn velgen in topconditie wil
                houden.
              </p>
              <div className="space-y-4 mb-8" data-id="element-717">
                <div className="flex items-center" data-id="element-718">
                  <div className="w-2 h-2 rounded-full bg-[#D6281F] mr-3" data-id="element-719"></div>
                  <span className="text-white/90" data-id="element-720">
                    Beschermt tegen stoepschade en steenslag
                  </span>
                </div>
                <div className="flex items-center" data-id="element-721">
                  <div className="w-2 h-2 rounded-full bg-[#D6281F] mr-3" data-id="element-722"></div>
                  <span className="text-white/90" data-id="element-723">
                    Verkrijgbaar in verschillende kleuren
                  </span>
                </div>
                <div className="flex items-center" data-id="element-724">
                  <div className="w-2 h-2 rounded-full bg-[#D6281F] mr-3" data-id="element-725"></div>
                  <span className="text-white/90" data-id="element-726">
                    Professionele installatie door BKCustoms in Almere
                  </span>
                </div>
                <div className="flex items-center" data-id="element-727">
                  <div className="w-2 h-2 rounded-full bg-[#D6281F] mr-3" data-id="element-728"></div>
                  <span className="text-white/90" data-id="element-729">
                    Duurzaam en weerbestendig materiaal
                  </span>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-730">
                <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center" data-id="element-731">
                  <span className="mr-2" data-id="element-732">Afspraak maken</span>
                  <ArrowRightIcon size={16} data-id="element-733" />
                </Link>
                <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10 inline-flex items-center justify-center" data-id="element-734">
                  Offerte aanvragen
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Benefits Section */}
      <section className="bg-[#0f0f0f] py-20" data-id="element-735">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-736">
          <div className="text-center mb-16" data-id="element-737">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-738">
              De <span className="text-[#D6281F]" data-id="element-739">Voordelen</span> van
              AlloyGator in Almere
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-740">
              Ontdek waarom AlloyGator de beste keuze is voor velgbescherming in
              Almere.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-741">
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-742">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-743">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-744" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-745">
                Optimale Bescherming
              </h3>
              <p className="text-white/80" data-id="element-746">
                AlloyGator biedt superieure bescherming tegen stoepschade,
                steenslag en andere alledaagse gevaren die uw velgen kunnen
                beschadigen.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-747">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-748">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-749" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-750">
                Kostenbesparend
              </h3>
              <p className="text-white/80" data-id="element-751">
                Voorkom dure reparaties of vervanging van beschadigde velgen.
                AlloyGator is een eenmalige investering die u op lange termijn
                geld bespaart.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-752">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-753">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-754" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-755">
                Esthetisch Aantrekkelijk
              </h3>
              <p className="text-white/80" data-id="element-756">
                Verkrijgbaar in verschillende kleuren om te matchen of juist te
                contrasteren met uw voertuig, voor een gepersonaliseerde look.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Color Options Section */}
      <section className="bg-[#0a0a0a] py-20" data-id="element-757">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-758">
          <div className="text-center mb-16" data-id="element-759">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-760">
              Beschikbare <span className="text-[#D6281F]" data-id="element-761">Kleuren</span> in
              Almere
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-762">
              Kies uit onze selectie kleuren om uw AlloyGator te personaliseren
              bij BKCustoms in Almere.
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4" data-id="element-763">
            <div className="bg-[#0a0a0a] border border-[#222] p-4 rounded-lg text-center" data-id="element-764">
              <div className="w-full aspect-square rounded-md bg-[#000000] mb-3" data-id="element-765"></div>
              <span className="text-white font-medium" data-id="element-766">Zwart</span>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-4 rounded-lg text-center" data-id="element-767">
              <div className="w-full aspect-square rounded-md bg-[#FF0000] mb-3" data-id="element-768"></div>
              <span className="text-white font-medium" data-id="element-769">Rood</span>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-4 rounded-lg text-center" data-id="element-770">
              <div className="w-full aspect-square rounded-md bg-[#0000FF] mb-3" data-id="element-771"></div>
              <span className="text-white font-medium" data-id="element-772">Blauw</span>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-4 rounded-lg text-center" data-id="element-773">
              <div className="w-full aspect-square rounded-md bg-[#FFFF00] mb-3" data-id="element-774"></div>
              <span className="text-white font-medium" data-id="element-775">Geel</span>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-4 rounded-lg text-center" data-id="element-776">
              <div className="w-full aspect-square rounded-md bg-[#00FF00] mb-3" data-id="element-777"></div>
              <span className="text-white font-medium" data-id="element-778">Groen</span>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-4 rounded-lg text-center" data-id="element-779">
              <div className="w-full aspect-square rounded-md bg-[#FFA500] mb-3" data-id="element-780"></div>
              <span className="text-white font-medium" data-id="element-781">Oranje</span>
            </div>
          </div>
          <p className="text-white/60 text-center mt-6" data-id="element-782">
            * Meer kleuren beschikbaar op aanvraag
          </p>
        </div>
      </section>
      {/* Installation Process Section */}
      <section className="bg-[#0f0f0f] py-20" data-id="element-783">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-784">
          <div className="text-center mb-16" data-id="element-785">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-786">
              Installatie <span className="text-[#D6281F]" data-id="element-787">Proces</span> in
              Almere
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-788">
              Bij BKCustoms in Almere volgen we een zorgvuldig proces om uw
              AlloyGator perfect te installeren.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-789">
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg relative" data-id="element-790">
              <div className="absolute -top-4 -left-4 bg-[#D6281F] w-8 h-8 rounded-full flex items-center justify-center text-white font-bold" data-id="element-791">
                1
              </div>
              <h3 className="text-xl font-bold text-white mb-4 mt-2" data-id="element-792">
                Voorbereiding
              </h3>
              <p className="text-white/80" data-id="element-793">
                We reinigen uw velgen grondig en controleren op eventuele
                bestaande schade die moet worden gerepareerd voordat de
                AlloyGator wordt geïnstalleerd.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg relative" data-id="element-794">
              <div className="absolute -top-4 -left-4 bg-[#D6281F] w-8 h-8 rounded-full flex items-center justify-center text-white font-bold" data-id="element-795">
                2
              </div>
              <h3 className="text-xl font-bold text-white mb-4 mt-2" data-id="element-796">
                Installatie
              </h3>
              <p className="text-white/80" data-id="element-797">
                Onze specialisten in Almere installeren de AlloyGator zorgvuldig
                tussen de velg en de band, waarbij ze zorgen voor een perfecte
                pasvorm en afwerking.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg relative" data-id="element-798">
              <div className="absolute -top-4 -left-4 bg-[#D6281F] w-8 h-8 rounded-full flex items-center justify-center text-white font-bold" data-id="element-799">
                3
              </div>
              <h3 className="text-xl font-bold text-white mb-4 mt-2" data-id="element-800">
                Afwerking
              </h3>
              <p className="text-white/80" data-id="element-801">
                Na installatie controleren we elke AlloyGator op correcte
                plaatsing en zorgen we ervoor dat uw velgen er perfect uitzien
                met hun nieuwe bescherming.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="bg-[#0a0a0a] py-16 border-t border-[#222]" data-id="element-802">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center" data-id="element-803">
          <h2 className="text-3xl font-bold text-white mb-6" data-id="element-804">
            Bescherm uw velgen vandaag nog in Almere!
          </h2>
          <p className="text-white/80 mb-8" data-id="element-805">
            Neem contact met ons op voor een persoonlijk advies of maak direct
            een afspraak voor jouw auto bij BKCustoms in Almere.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-806">
            <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide" data-id="element-807">
              Afspraak maken
            </Link>
            <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10" data-id="element-808">
              Contact opnemen
            </Link>
          </div>
        </div>
      </section>
    </main>;
};